var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5958 16.4043C41.85 12.6585 36.7091 10.3335 31 10.3335C19.5816 10.3335 10.3591 19.5818 10.3591 31.0002C10.3591 42.4185 19.5816 51.6668 31 51.6668C40.6358 51.6668 48.67 45.0793 50.9691 36.1668H45.5958C43.4775 42.186 37.7425 46.5001 31 46.5001C22.4491 46.5001 15.5 39.551 15.5 31.0002C15.5 22.4493 22.4491 15.5002 31 15.5002C35.2883 15.5002 39.1116 17.2827 41.9016 20.0985L33.5833 28.4168H51.6666V10.3335L45.5958 16.4043Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh.4e78733a70df0168f47254ae86fb5bfe.svg";